import { generateFirestoreDocumentID } from "./id-generator";

let deviceID: string | undefined;

export function getDeviceID(): string {
    let maybeDeviceID = deviceID;
    if (maybeDeviceID === undefined) {
        maybeDeviceID = generateFirestoreDocumentID();
        deviceID = maybeDeviceID;
    }
    return maybeDeviceID;
}
